import { useEffect } from 'react';

const SELECTORS = {
  description: 'meta[name="description"]',
  canonical: 'link[rel="canonical"]',
  ogTitle: 'meta[property="og:title"]',
  ogDescription: 'meta[property="og:description"]',
  ogUrl: 'meta[property="og:url"]',
  twitterTitle: 'meta[name="twitter:title"]',
  twitterDescription: 'meta[name="twitter:description"]',
};

function attrFor(el) {
  return el.tagName === 'LINK' ? 'href' : 'content';
}

// Page-level title, description and canonical URL for routes other than the home page.
export default function useDocumentMeta({ title, description, path }) {
  useEffect(() => {
    const url = `${window.location.origin}${path}`;
    const values = {
      description,
      canonical: url,
      ogTitle: title,
      ogDescription: description,
      ogUrl: url,
      twitterTitle: title,
      twitterDescription: description,
    };
    const previous = { title: document.title };
    document.title = title;
    Object.entries(SELECTORS).forEach(([key, selector]) => {
      const el = document.querySelector(selector);
      if (!el) return;
      previous[key] = el.getAttribute(attrFor(el));
      el.setAttribute(attrFor(el), values[key]);
    });
    return () => {
      document.title = previous.title;
      Object.entries(SELECTORS).forEach(([key, selector]) => {
        const el = document.querySelector(selector);
        if (el && previous[key] != null) el.setAttribute(attrFor(el), previous[key]);
      });
    };
  }, [title, description, path]);
}
